module.exports = __webpack_public_path__ + "img/headerprofileimg.d3aa2766.svg";